import { Component, ErrorInfo, ReactNode } from 'react'
import { Button, tokens } from '@fluentui/react-components'
import { ArrowClockwise24Regular, ErrorCircle24Regular } from '@fluentui/react-icons'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: '16px',
          padding: '24px',
          backgroundColor: tokens.colorNeutralBackground1,
          textAlign: 'center',
          fontFamily: 'Segoe UI, system-ui, sans-serif'
        }}>
          <ErrorCircle24Regular style={{ color: tokens.colorPaletteRedForeground1, fontSize: '48px' }} />
          <h2 style={{ 
            fontSize: '20px', 
            fontWeight: '600', 
            color: tokens.colorNeutralForeground1,
            margin: 0
          }}>
            Something went wrong
          </h2>
          <p style={{ 
            color: tokens.colorNeutralForeground2, 
            fontSize: '14px', 
            maxWidth: '400px', 
            lineHeight: '1.5',
            margin: 0
          }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <Button 
            appearance="primary" 
            icon={<ArrowClockwise24Regular />}
            onClick={() => window.location.reload()}
          >
            Reload App
          </Button>
        </div>
      )
    }

    return this.props.children
  }
}
